<template>
  <div class="custom-select" ref="select">
    <div class="selected-option" @click="isOpen = !isOpen">
      <span v-if="selectedOption" class="input-box">
        <span style="display: flex; flex-direction: column">
          <span class="custom-label">{{ placeholder }} </span>
          <span class="select-text">
            {{ selectedOption }}
          </span>
        </span>
        <img
          src="@/assets/images/icons/interface-arrow-dropdown.png"
          :alt="`dropdown icon`"
        />
      </span>
      <span v-else class="input-box">
        <span style="display: flex; flex-direction: column">
          <span class="select-text-placeholder">
            {{ placeholder }}
          </span>
        </span>
        <img src="@/assets/images/icons/help.png" :alt="`dropdown icon`" />
      </span>
    </div>
    <div class="options" v-show="isOpen">
      <div
        class="option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option, index)"
      >
        <span v-if="type == 'country' || type == 'id'">
          {{ option.name }}
        </span>
        <span v-else>
          {{ option }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDetailsSelect",
  data() {
    return {
      isOpen: false,
      selectedOption: this.setDefault(),
      selectedIndex: null,
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "default",
    },
    value: null,
  },
  methods: {
    scrollTo1980() {
      const currentYear = new Date().getFullYear();
      const totalYears = currentYear - 1930;
      const positionOf1980 = 1980 - 1930;
      const optionHeight = 48; // assuming each option has a height of 48px

      const scrollAmount = (totalYears - positionOf1980) * optionHeight;
      const optionsContainer = this.$refs.select.querySelector(".options");
      optionsContainer.scrollTop = optionsContainer.scrollHeight - scrollAmount;
    },
    setDefault() {
      if (this.value == null || this.value == "" || this.value == undefined) {
        return undefined;
      }
      if (this.type == "country" || this.type == "id") {
        // find value in options
        const found = this.options.find((element) => element.code == this.value);
        return found.name;
      } else {
        return this.value;
      }
    },
    selectOption(option, index) {
      if (this.type == "country" || this.type == "id") {
        this.selectedOption = option.name;
        this.$emit("input", option.code);
      } else {
        this.selectedOption = option;
        this.$emit("input", option);
      }
      this.selectedIndex = index;
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.select.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    if (this.type == "id") {
      this.selectedOption = this.options[0].name;
      this.$emit("input", this.options[0].code);
    }
    // this.selectedOption = this.options[0];
    document.addEventListener("click", this.handleClickOutside);
  },
  watch: {
    value: function (val) {
      if (this.type == "country" || this.type == "id") {
        // find value in options
        const found = this.options.find((element) => element.code == val);
        this.selectedOption = found ? found.name : null;
      } else {
        this.selectedOption = val;
      }
    },
    isOpen(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          const optionsContainer = this.$refs.select.querySelector(".options");
          // log optionsContainer.scrollHeight
          optionsContainer.scrollBy(0, 1);
          optionsContainer.scrollBy(0, -1);
        });
      }
      if (newValue && this.type === "age") {
        this.$nextTick(() => {
          this.scrollTo1980();
        });
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.input-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.custom-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/2 */

  color: #5b626f;
}
.select-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/default */

  color: #30384a;
}
.select-text-placeholder {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/placeholder */

  color: #878b95;
}
.custom-select {
  position: relative;
  background-color: #f6f6f4;
  height: 64px;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
}
.selected-option {
  background-color: white;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  line-height: 1.5;
  padding: 16px;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  border: 2px solid #d1d2d6;
}
.options {
  position: absolute;
  max-height: 400px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: scroll;
  /* -ms-overflow-style: none; 
  scrollbar-width: none; */
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05), 0px 4px 4px -1px rgba(0, 0, 0, 0.05),
    0px 12px 16px -8px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

.options::-webkit-scrollbar {
  /* display: none; */
}
.option {
  padding: 16px;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
}
.option:hover {
  background: #f2f3f4;
}
</style>
